import { Response, TemplateIdentifier } from '@candu-ai/first-mate/api';

export const TEMPLATE_SUGGESTIONS_URI = '/api/first-mate/template-suggestions';

export type SuggestionsRequest = {
  prompt: string;
};
export type Suggestions = Response<TemplateIdentifier[]>;
